import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LanguageCode } from '../../common/Conf';
import Helpers from '../../common/Helpers';
import CarrouselWithThumbs from '../../components/CarrouselComponent/CarrouselWithThumbs';
import CheckboxSwitch from '../../components/CheckboxSwitchComponent/CheckboxSwitch';
import PlusMinus from '../../components/PlusMinusComponent/PlusMinus';
import { dicNames, i18n } from '../../lang/i18n';
import { actAlertShow, actCartProductAdd } from '../../store/Actions';
import { CartProductItem, CartItemModel } from '../../store/Cart/CartModel';
import ProductsBlock from './ProductsBlock';
import { Rating } from 'react-simple-star-rating'
import ScrollToTop from '../../components/ScrollToTop';
import DC from '../../common/DataConnector';
import { reducerAppDataUpdateProductRating } from '../../store/AppData/AppDataReducer';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

export default function ProductDetails()
{
    const dispatch = useAppDispatch()
    const appData = useAppSelector((state) => state.appData)
    const userData = useAppSelector((state) => state.userData)
    const navigate = useNavigate();
    const { productCode } = useParams()
    const productUrl = productCode ? productCode.split('-') : []
    const pCode = productUrl.length > 1 ? productUrl[productUrl.length - 1] : productCode;
    const [product, setProduct] = useState<any>(undefined);
    const [cartItem, setCartItem] = useState<CartItemModel>({
        quantity: 1, preferences: [],
        priceOld: 0,
        priceFinal: 0,
        priceFinalNet: 0,
        priceFinalVat: 0,
        priceBase: 0
    })

    useEffect(() =>
    {
        if (pCode && appData.productsDic[pCode]) {
            const p = appData.productsDic[pCode];
            setProduct(p)
            setCartItem({
                quantity: 1, preferences: preferencesStart(p),
                priceOld: p.priceOld,
                priceFinal: p.price,
                priceFinalNet: p.priceNet,
                priceFinalVat: p.priceVat,
                priceBase: p.price
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pCode]);

    function onQuantityChange(value: number)
    {
        let q = cartItem.quantity + value
        if (q < 1) q = 1
        refreshPrice({ ...cartItem, quantity: q })
    }

    function onAddToCart(buyNow: boolean)
    {
        const productItem: CartProductItem = {
            quantity: cartItem.quantity,
            price: cartItem.priceFinal,
            priceNet: cartItem.priceFinalNet,
            priceVat: cartItem.priceFinalVat,
            product: product, discount: 0,
            preferences: cartItem.preferences,
            notes: '',
            title: product.title,
            priceBase: cartItem.priceBase, useRitmitos: false
        }
        actCartProductAdd(dispatch,productItem)
        if (buyNow)
            navigate('/cart')
        else
            navigate('/')
    }

    function preferencesStart(product: any)
    {
        let items: any[] = [];
        for (let x = 0; x < product.extras.length; x++) {
            const extra = appData.productExtras[product.extras[x]];
            let price: any = { price: 0, priceNet: 0 }
            switch (extra.extraType) {
                case 'bool':
                    items.push({ extraId: product.extras[x], type: extra.extraType, value: false, price: 0, priceNet: 0 });
                    break;
                case 'list':
                    items.push({ extraId: product.extras[x], type: extra.extraType, value: extra.conf.list[0].id, price: price.price, priceNet: price.priceNet });
                    break;
                case 'extras':
                    const value = extra.conf.extras[0].value
                    const prices = product.extrasPrice[value];
                    if (prices) {
                        if (prices.priceOffer > 0) {
                            price.price = prices.priceOffer;
                            price.priceNet = prices.priceOfferNet;
                        } else {
                            price.price = prices.price;
                            price.priceNet = prices.priceNet;
                        }
                    }
                    items.push({ extraId: product.extras[x], type: extra.extraType, value: value, price: price.price, priceNet: price.priceNet });
                    break;
            }
        }
        return items;
    }

    function refreshPrice(item: CartItemModel)
    {
        item.priceFinal = item.quantity * product.price
        item.priceFinalNet = Helpers.Number2Digit(item.quantity * product.priceNet)
        if (product.priceOld === 0) {
            item.priceOld = 0
        } else {
            item.priceOld = item.quantity * product.priceOld
        }
        for (let x = 0; x < item.preferences.length; x++) {
            item.priceFinal += (item.preferences[x].price * item.quantity)
            item.priceFinalNet += (item.preferences[x].priceNet * item.quantity)
        }
        item.priceFinalVat = Helpers.Number2Digit(item.priceFinal - item.priceFinalNet);
        setCartItem({ ...cartItem, ...item })
    }


    function preferencesRefresh(index: number, extraValue: string, value: any)
    {
        let ps = [...cartItem.preferences]
        const prices = product.extrasPrice[extraValue];
        ps[index].price = 0;
        ps[index].priceNet = 0;
        ps[index].extraValue = extraValue;
        switch (ps[index].type) {
            case 'bool':
                ps[index].value = value
                if (prices && value) {
                    ps[index].price = prices.price;
                    ps[index].priceNet = prices.priceNet;
                    ps[index].priceBase = prices.price;
                }
                break;
            case 'extras':
                ps[index].value = extraValue
                if (prices) {
                    ps[index].price = prices.price;
                    ps[index].priceNet = prices.priceNet;
                    ps[index].priceBase = prices.priceBase;
                }
                break;
            case 'list':
                ps[index].value = value
                break;
        }
        ps[index].priceVat = ps[index].price - ps[index].priceNet;
        const cart = { ...cartItem, preferences: ps }
        refreshPrice(cart)
    }

    function extrasList(): any[]
    {
        const items: any[] = []
        for (let x = 0; x < cartItem.preferences.length; x++) {
            const extra = appData.productExtras[cartItem.preferences[x].extraId];
            switch (cartItem.preferences[x].type) {
                case 'bool':
                    items.push(extraYesNo(x, extra, cartItem.preferences[x].value));
                    break;
                case 'extras':
                    items.push(extraExtras(x, extra, cartItem.preferences[x].value));
                    break;
                case 'list':
                    items.push(extraList(x, extra, cartItem.preferences[x].value));
                    break;
            }
        }
        return items;
    }

    function extraYesNo(index: number, extra: any, value: boolean)
    {
        let ln = extra.conf.titles[LanguageCode] ? LanguageCode : ('es_' + (value ? "yes" : "no"));
        const title = extra.conf.titles[ln];

        return (<div style={{ flex: 1, paddingBottom: 10, paddingTop: 15, textAlign: 'center' }} key={index}>
            <span style={{ textAlign: 'right', marginRight: 10, fontSize: 20 }}>{title}</span>
            <CheckboxSwitch conf={{ active: value, textActive: "", textDeactivate: "", fieldName: '' }}
                style={{ display: 'inline' }}
                onChange={(e: any, conf: any) =>
                {
                    preferencesRefresh(index, extra.conf.extra.value, conf.active);
                    return true;
                }}
            />
        </div>)
    }
    function extraList(index: number, extra: any, value: any)
    {
        const ln = extra.conf.titles[LanguageCode] ? LanguageCode : 'es';
        let title = extra.conf.titles[ln];
        return (<div key={index} style={{ display: 'flex', flex: 1, paddingBottom: 10, paddingTop: 15, textAlign: 'center', flexDirection: 'row' }}>
            <span style={{ flex: 0.5, textAlign: 'right', alignItems: 'flex-end', marginRight: 10, fontSize: 20 }}>{title}</span>
            <div style={{ display: 'flex', marginRight: 20, flex: 0.5, alignItems: 'flex-end' }}>
                <select onChange={(e: any) =>
                {
                    preferencesRefresh(index, e.target.value, e.target.value)
                }} value={value}>
                    {extra.conf.list.map((item: any, itemIndex: number) => (
                        <option value={item.id} key={index + '_' + itemIndex}>{item.name[ln]}</option>
                    ))}
                </select>
            </div>
        </div>)
    }

    function extraExtras(index: number, extra: any, value: any)
    {
        const ln = extra.conf.titles[LanguageCode] ? LanguageCode : 'es';
        let allPricesAre0 = true;
        for (let x in extra.conf.extras) {
            if (product.extrasPrice[extra.conf.extras[x].value] && product.extrasPrice[extra.conf.extras[x].value].price > 0)
                allPricesAre0 = false;
        }
        return (<div key={index} className="product-details-extras">
            {extra.conf.extras.map((item: any, indexExtra: number) => (
                <div key={index + '_' + indexExtra}
                    onClick={() => { preferencesRefresh(index, item.value, item.value) }}
                    className={item.value === value ? 'extra-active' : 'extra-deactivate'}>
                    <div style={{ flex: 1 }}>
                        <div >{item.titles[ln]}</div>
                        {!allPricesAre0 && product.extrasPrice[item.value] && <span >+ {product.extrasPrice[item.value].price}€</span>}
                    </div>
                </div>
            ))}
        </div>)
    }

    function renderStock(item: any)
    {
        if (!item.isOneGoods || item.stockCurrent <= 0) return <></>
        if (item.stockCurrent < 5)
            return <b><small>{i18n.ProductDetails.onlyRemain} {item.stockCurrent}</small></b>
        return <small>{i18n._Labels.available}</small>
    }

    function renderDescription(description: string)
    {
        if (!description) return null;
        const lines = description.split('\n');
        return <>{lines.map((item: string, index: number) => (
            <p key={index}>{item}</p>
        ))}</>
    }
    async function onProductRatingClick(rate: number)
    {
        if (!userData.isActive) {
            actAlertShow(dispatch, 'danger', i18n.ProductDetails.MustRegisterToRating)
            return;
        }
        if (!pCode) return;
        dispatch(reducerAppDataUpdateProductRating({ productCode: productCode, rating: rate }))
        await DC.Post('/customer/reviews', { productCode: pCode, rating: rate })
    }

    if (!product)
        return <div className="product-details">
            <div style={{ paddingTop: '100px', paddingBottom: '50px', fontSize: '25px' }}>
                {i18n.ProductDetails.ProductNotFound}
            </div>
        </div>
    const items = extrasList()

    return (<div className="product-details">
        <ScrollToTop />
        <div className="product-details-header">
            <div className='product-details-header-image' style={{ backgroundImage: `url(${product.photo.url500})` }}>
            </div>
            <div className='product-details-rating'>
                {i18n.ProductDetails.YourAssessment}: <Rating size={22} initialValue={product.rating} onClick={onProductRatingClick} />
            </div>
            <div className='product-details-title'>
                <div style={{ flex: 1 }}><h3>{product.title}</h3></div>
                <label>{product.price.toFixed(1)}€</label>
                {product.priceOld > 0 && <del><small>{product.priceOld.toFixed(1)}€</small></del>}
                {product.priceOld === 0 && <small>({product.loyaltyAmount}⚡)</small>}
            </div>
        </div>
        <div className='product-details-body mb-1'>
            {items.length > 0 && <div className='product-details-section-title'>
                <span>{i18n.ProductDetails.SelectPreferences}</span>
            </div>}
            {items}
            <div className='product-details-total'>

                <div className='product-details-price'>
                    <label>{cartItem.priceFinal.toFixed(1)}€</label>
                </div>
                <PlusMinus size={1}
                    value={cartItem.quantity} onValueChange={onQuantityChange} type="main" />
            </div>
            <div className='product-details-stock'>
                {renderStock(product)}
            </div>
            <div className='product-details-btns'>
                <button className="btn btn-pay-cart"
                    onClick={() => onAddToCart(false)}>
                    {i18n.ProductDetails.BTNAddToCart}
                </button>
                <button className="btn btn-pay-cart mt-3"
                    onClick={() => onAddToCart(true)}>
                    {i18n.ProductDetails.BTNBuyNow}
                </button>
            </div>
            <div>
                {product.tags.map((item: string, index: number) => (
                    <span className="badge badge-light mr-1" key={index}>{item}</span>
                ))}
            </div>
            <div>
                {product.allergens && product.allergens.map((item: string, index: number) => (
                    <span className="badge badge-pill badge-warning mr-1" key={index}>{dicNames[item]}</span>
                ))}
            </div>
            <div className="mt-3 mb-3">
                {renderDescription(product.description)}
            </div>
            <ProductsBlock productCode={product.productCode} type="category" />
            <div className="mt-2 mb-5">
                <div className='product-details-section-title'>{i18n.ProductDetails.MoreInformation}</div>
                <CarrouselWithThumbs images={product.photos} />
                {renderDescription(product.descriptionLong)}
            </div>
            <div className='product-details-btns'>
                <button className="btn btn-pay-cart"
                    onClick={() => onAddToCart(false)}>
                    {i18n.ProductDetails.BTNAddToCart}
                </button>
                <button className="btn btn-pay-cart mt-3"
                    onClick={() => onAddToCart(true)}>
                    {i18n.ProductDetails.BTNBuyNow}
                </button>
            </div>
        </div>
    </div>
    )
}